import { createSelector } from 'reselect';
import { getCompany } from '../ducks';
import { hasCurrentEnterpriseId } from './session/privileges';

export const getCompanyChainIdIfNoEnterpriseId = createSelector(
    hasCurrentEnterpriseId,
    getCompany,
    (hasEnterpriseId, company) => (!hasEnterpriseId && company?.chainId ? company.chainId : null)
);
